import { ImprovedProduct } from "../../../Interfaces/Product";

const products: ImprovedProduct[] = [
  {
    sku: 124,
    name: "Peanut brittle",
    description: "Peanut Brittle",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/124_20260217_005931.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 577,
    name: "40 oz Burgundy Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/577_20250824_133817.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 701,
    name: "White Racerback Tank Top",
    description: "White Racerback Tank Top",
    base_price: 30,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/701_20250824_133242.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 102,
    name: "Butter Toffee Peanuts 7oz",
    description:
      "Toffee-coated peanuts unite in a sweet and        buttery symphony, blending caramelized richness with nutty crunch,        delivering a delightful indulgence in every bite. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/102_20250824_132446.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 104,
    name: "Mixed Nuts 6oz",
    description:
      "A diverse mix of peanuts and assorted nuts, delivering        a satisfying crunch and a harmonious blend of flavors in every handful.        6 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/104_20250824_132542.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 301,
    name: "Chocolate Chip Cookies (8-3oz)",
    description:
      "Indulge in our 3 oz chocolate chip cookies, individually        wrapped for convenience. Each bite boasts the rich, velvety taste of Hershey’s        chocolate, ensuring a decadent and delightful treat. Full of Hershey’s chocolate        chips and rich Hershey’s Mini Kisses. Made with pure cane sugar, Hershey’s Mini        Kisses and Hershey’s chocolate chips.Contains: milk, egg, wheat, soy8        count (3 oz. Jumbo Soft Baked Cookies)",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/301_20250824_133315.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 705,
    name: "Black Racerback Tank Top",
    description: "Black Racerback Tank Top",
    base_price: 30,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/705_20250824_133139.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 304,
    name: "White Chocolate Macadamia Cookies (8-3oz)",
    description:
      "Delight in our 3 oz individually wrapped white chocolate        macadamia cookies, infused with white chocolate chips. Each bite offers a warm        and comforting taste, creating a delightful treat.Contains: milk, egg,        wheat, soy8 count (3 oz. Jumbo Soft Baked Cookies)",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/304_20250824_133342.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 1000002,
    name: "Groveport Bear",
    description: "Groveport Bear",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/fundraiser24/products/1000002_20250824_132649.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 207,
    name: "Chocolate Delight 13oz",
    description:
      "Savor chocolate-covered caramel corn: the perfect union        of velvety chocolate and buttery caramel, creating a delectable symphony of        sweet and savory satisfaction. Individual Size Bag – 13 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/207_20250824_133206.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 576,
    name: "40 oz Black Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/576_20250824_133826.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 125,
    name: "Dark Chocolate Tropical Coconut Dreams",
    description: "Dark Chocolate Tropical Coconut Dreams",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/125_20260217_010636.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 302,
    name: "Peanut Butter Cookies (8-3oz)",
    description:
      "Savor our 3 oz individually wrapped peanut butter cookies,        crafted with luscious Reese’s peanut butter. Each bite delivers a perfect blend        of sweet and nutty indulgence, ensuring a delightful treat. Made with pure cane        sugar and Reese’s Peanut Butter Chips.Contains: milk, egg, wheat, soy, peanuts8        count (3 oz. Jumbo Soft Baked Cookies)",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/302_20250824_133324.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 303,
    name: "Cinnabon Cookies (8-3oz)",
    description:
      "Delight in our 3 oz individually wrapped cinnamon cookies,        infused with the irresistible flavor of Cinnabon. Each bite offers a warm and        comforting taste, creating a delightful treat. Made with pure cane sugar and        Cinnabon cinnamon and cream cheese chips.Contains: milk, egg, wheat, soy8        count (3 oz. Jumbo Soft Baked Cookies)",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/303_20250824_133332.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 478,
    name: "Grey Custom Hoodie",
    description: "grey",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/478_20250824_133836.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 677,
    name: "30 oz Green Organization Tumbler",
    description: "30 oz Green Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/677_20250824_133355.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 106,
    name: "Sweet n Crunchy Trail Mix 7oz",
    description:
      "A sweet and crunchy trail mix, combining the allure        of chocolate-covered candies with a diverse blend of nuts and dried fruits        for a delightful snacking experience. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/106_20250824_132559.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 110,
    name: "Peanut Butter Bears 6.5oz",
    description:
      "Peanut butter bears, adorable and delectable, are        bite-sized treats with a creamy peanut butter center, providing a satisfying        blend of sweetness and nutty goodness. 6 oz",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/110_20250824_132634.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 205,
    name: "Fruity Popcorn 23.5oz",
    description:
      "Gluten FreeFruity popcorn bursts with a spectrum of        flavors, coating each kernel in vibrant fruity sweetness, creating a colorful        and delightful snacking experience that tantalizes your taste buds. Family        Size Bag – 23.5 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/205_20250824_133147.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 601,
    name: "40 oz Black Travel Mug",
    description: "40 oz Black Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/601_20250824_133702.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 526,
    name: "20 oz Black Organization Bottle",
    description:
      "Our 20 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 35,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/526_20250824_133918.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 1000005,
    name: "U4Meme4U Bear",
    description: "Custom Bear",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/fundraiser48/products/1000005_20250824_132512.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 1000003,
    name: "On Pointe Glitz Cheer Bear",
    description: "On Pointe Glitz Bear",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/fundraiser23/products/1000003_20250824_132628.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 126,
    name: "Cookies N Cream",
    description: "Cookies N Cream",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/126_20260217_010656.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 101,
    name: "Chocolate Almonds 5oz",
    description:
      "Crunchy almonds coated in luscious chocolate,        a harmonious fusion of nuttiness and sweetness, offering a delectable        treat for your palate. 5 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/101_20250824_132434.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 113,
    name: "Chocolate Covered Pretzels 6oz",
    description:
      "Crunchy pretzels enrobed in velvety chocolate, a perfect        balance of sweet and salty, delivering a satisfying blend of textures in every        bite, a delightful indulgence. 6 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/113_20250824_132745.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 480,
    name: "Navy Blue Custom Hoodie",
    description: "navy",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/480_20250824_133904.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 627,
    name: "40 oz Light Blue Organization Travel Mug",
    description: "40 oz Light Blue Organization Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/627_20250824_133610.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 604,
    name: "40 oz Purple Travel Mug",
    description: "40 oz Purple Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/604_20250824_133640.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 1000004,
    name: "On Pointe Bear",
    description: "On Pointe Dance Bear",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/fundraiser23/products/1000004_20250824_132605.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 1000001,
    name: "Miss National Extraordinaire Bear",
    description: "Miss National Extraordinaire Bear",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/fundraiser6/products/1000001_20250824_132727.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 118001,
    name: "Cashew Snack Mix Big Bag",
    description:
      "A simple mix that is simply delicious. Sesame sticks, peanuts,         and cashews roasted and lightly         salted to tantalize your taste buds. 12 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/118001_20250824_132900.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 127,
    name: "Nashville Hot Honey Peanuts",
    description: "Nashville Hot Honey Peanuts",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/127_20260317_172453.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 103,
    name: "Cranberry Fitness Mix 6oz",
    description:
      "Vibrant cranberries, wholesome nuts, and seeds unite        in a nutritious medley, offering a burst of energy and flavors for active        lifestyles. 6 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/103_20250824_132532.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 105,
    name: "Hot & Spicy Nuts 7oz",
    description:
      "Fiery and bold, this mix of nuts packs a spicy punch,        tantalizing your taste buds with a perfect blend of heat and crunch. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/105_20250824_132552.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 123,
    name: "Mint Patties 6oz",
    description: "Mint Patties",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/123_20250824_132931.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 679,
    name: "30 oz Red Organization Tumbler",
    description: "30 oz Red Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/679_20250824_133335.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 676,
    name: "30 oz Black Organization Tumbler",
    description: "30 oz Black Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/676_20250824_133404.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 107,
    name: "Gummi Bears 7oz",
    description:
      "Chewy and colorful gummi bears, bursting with fruity        flavors, creating a playful and delightful treat for a sweet and satisfying        experience. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/107_20250824_132606.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 109,
    name: "Fruit Slices 10oz",
    description:
      "Gummy fruit slices, brightly colored and irresistibly        chewy, offer a burst of fruity sweetness in every bite, creating a delightful        and colorful snacking experience. 10 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/109_20250824_132625.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 111,
    name: "English Butter Toffee 6oz",
    description:
      "Toffee bites, bite-sized delights of rich caramelized        flavor, deliver a sweet and buttery indulgence with each crunchy and satisfying        piece. 6 oz",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/111_20250824_132644.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 128,
    name: "Churro Flavored Peanuts",
    description: "Churro Flavored Peanuts",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/128_20260317_172255.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 114,
    name: "Chocolate Covered Raisins 7oz",
    description:
      "Plump raisins coated in smooth chocolate, a delightful        fusion of sweetness, chewiness, and richness, creating a perfect treat for        sweet cravings. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/114_20250824_132754.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 112,
    name: "Pecanbacks 7.5oz",
    description:
      "Pecan buds, tiny delights of caramelized bliss and pecan        goodness, harmonize sweet and nutty notes for a delightful munch in every        bite. 7 oz",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/112_20250824_132656.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 115,
    name: "Cracked Pepper & Sea Salt Cashews 5oz",
    description:
      "Cracked pepper & sea salt cashews: premium crunch, savory        and spicy blend, delivering a perfect balance of bold flavors in every bite.        5 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/115_20250824_132804.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 119,
    name: "Cashew Halves 5oz",
    description:
      "Delicately roasted and lightly salted, these cashew halves         are everyone’s favorite snack. 5 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/119_20250824_132852.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 116,
    name: "Honey Roasted Peanuts 7oz",
    description:
      "Golden sweetness and crunchy perfection collide in        honey-roasted peanuts, offering a delightful fusion of honey-kissed flavor        and satisfying nutty goodness. 7 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/116_20250824_132814.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 201,
    name: "Kettle Popcorn 22oz",
    description:
      "Gluten FreeKettle corn, a sweet and salty popcorn        sensation, boasts a crispy texture and an irresistible flavor blend that        delights the taste buds with every satisfying crunch. Family Size Bag – 22 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/201_20250824_133112.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 202,
    name: "Buttery Caramel Popcorn 23.5oz",
    description:
      "Gluten FreeIndulge in the symphony of flavors with        buttery caramel popcorn, where each crunchy kernel harmonizes rich butter        essence and sweet caramel for a mouthwatering, irresistible treat. Family        Size Bag – 23.5 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/202_20250824_133121.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 116001,
    name: "Honey Roasted Peanuts Big Bag",
    description:
      "Golden sweetness and crunchy perfection collide in        honey-roasted peanuts, offering a delightful fusion of honey-kissed flavor        and satisfying nutty goodness. 16 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/116001_20250824_132916.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 109001,
    name: "Fruit Slices Big Bag",
    description:
      "Gummy fruit slices, brightly colored and irresistibly        chewy, offer a burst of fruity sweetness in every bite, creating a delightful        and colorful snacking experience. 14 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/109001_20250824_132929.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 108001,
    name: "Neon Sour Gummi Worms Big Bag",
    description:
      "Vibrant neon sour gummy worms, tangy and chewy, deliver        a burst of fruity flavors that awaken your taste buds with a fun and sour        twist. 14 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/108001_20250824_132945.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 107001,
    name: "Gummi Bears Big Bag",
    description:
      "Chewy and colorful gummi bears, bursting with fruity        flavors, creating a playful and delightful treat for a sweet and satisfying        experience. 14 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/107001_20250824_132959.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 129,
    name: "Cheeseburger Flavored Peanuts",
    description: "Cheeseburger Flavored Peanuts",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/129_20260317_172343.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 108,
    name: "Neon Sour Gummi Worms 9oz",
    description:
      "Vibrant neon sour gummy worms, tangy and chewy, deliver        a burst of fruity flavors that awaken your taste buds with a fun and sour        twist. 9 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/108_20250824_132615.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 105001,
    name: "Hot & Spicy Nuts Big Bag",
    description:
      "Fiery and bold, this mix of nuts packs a spicy punch,        tantalizing your taste buds with a perfect blend of heat and crunch. 16 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/105001_20250824_133044.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 130,
    name: "Taco Flavored Peanuts",
    description: "Taco Flavored Peanuts",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/130_20260317_172423.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 118,
    name: "Cashew Snack Mix 6oz",
    description:
      "A simple mix that is simply delicious. Sesame sticks, peanuts,         and cashews roasted and lightly         salted to tantalize your taste buds. 6 oz",
    base_price: 12,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/118_20250824_132841.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 120,
    name: "Dark Sea Salt Caramels 6oz",
    description: "Dark Sea Salt Caramels",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/120_20250824_132902.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 121,
    name: "Cashew Backs 7oz",
    description: "Cashew Backs",
    base_price: 15,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/121_20250824_132912.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 122,
    name: "Katydids 8oz",
    description: "Katydids",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/122_20250824_132921.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 211,
    name: "White Cheddar 9.5oz",
    description: "White Cheddar",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/211_20250824_133253.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 212,
    name: "Strawberry Shortcake 13oz",
    description: "Strawberry Shortcake",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/212_20250824_133305.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 681,
    name: "30 oz White Organization Tumbler",
    description: "30 oz White Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/681_20250824_133307.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 131,
    name: "Black Pepper Cashews",
    description: "Black Pepper Cashews",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/131_20260317_172559.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 203,
    name: "Cheesy Cheddar Popcorn 9.5oz",
    description:
      "Gluten FreeCheesy cheddar popcorn offers a savory        explosion of flavor with its golden kernels coated in a rich, sharp cheddar        seasoning, delivering a satisfyingly cheesy and crunchy snack experience.        Family Size Bag – 9.5 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/203_20250824_133130.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 206,
    name: "Cheddar Jalapeno Popcorn 9.5oz",
    description:
      "Gluten FreeJalapeño cheddar popcorn ignites your palate        with a spicy kick and savory cheddar fusion, delivering a bold and flavorful        experience that combines heat with cheesy indulgence in every kernel. Family        Size Bag – 9.5 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/206_20250824_133156.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 208,
    name: "Movie Theater Popcorn 8oz",
    description:
      "Experience movie magic with buttery perfection: movie        theater popcorn, a classic, irresistible treat, offers delightful kernels        enhanced by a touch of salt. Family Size Bag – 8 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/208_20250824_133215.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 209,
    name: "Cookies & Cream Popcorn 13oz",
    description:
      "We’ve elevated our Signature Cookies & Cream Popcorn!        The allure of chocolate-coated popcorn meets freshly glazed white chocolate,        delivering superior taste in every delightful nibble. Individual Size Bag –        13 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/209_20250824_133230.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 210,
    name: "Texas Cheddar Habanero 9.5oz",
    description:
      "Experience the bold kick of Texas Cheddar Habanero Popcorn.        Savory cheddar meets fiery habanero, creating a spicy and flavorful delight in        every crunchy kernel. Family Size Bag – 9.5 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/210_20250824_133241.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 106001,
    name: "Sweet n Crunchy Trail Mix Big Bag",
    description:
      "A sweet and crunchy trail mix, combining the allure        of chocolate-covered candies with a diverse blend of nuts and dried fruits        for a delightful snacking experience. 16 oz",
    base_price: 22,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/106001_20250824_133031.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 501,
    name: "20 oz Black Bottle",
    description:
      "Our 20 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 35,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/501_20250824_133929.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 630,
    name: "40 oz White Organization Travel Mug",
    description: "40 oz White Organization Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/630_20250824_133545.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 132,
    name: "Sweet and Smokey Cashews",
    description: "Sweet and Smokey Cashews",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/132_20260317_172626.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 556,
    name: "40 oz Royal Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/556_20250824_133833.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 629,
    name: "40 oz Purple Organization Travel Mug",
    description: "40 oz Purple Organization Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/629_20250824_133554.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 450,
    name: "Black Custom Shirt",
    description: "Black",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/450_20250824_133423.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 452,
    name: "Grey Custom Shirt",
    description: "grey",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/452_20250824_133506.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 454,
    name: "Navy Blue Custom Shirt",
    description: "navy",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/454_20250824_133539.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 456,
    name: "Red Custom Shirt",
    description: "red",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/456_20250824_133611.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 458,
    name: "Royal Blue Custom Shirt",
    description: "royal",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/458_20250824_133641.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 460,
    name: "White Custom Shirt",
    description: "white",
    base_price: 25,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/460_20250824_133721.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 476,
    name: "Black Custom Hoodie",
    description: "black",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/476_20250824_133759.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 555,
    name: "40 oz Red Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/555_20250824_133839.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 550,
    name: "40 oz Black Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/550_20250824_133908.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 482,
    name: "Red Custom Hoodie",
    description: "red",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/482_20250824_133933.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 484,
    name: "Royal Blue Custom Hoodie",
    description: "royal",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/484_20250824_134001.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 655,
    name: "30 oz Royal Tumbler",
    description: "30 oz Royal Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/655_20250824_133441.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 653,
    name: "30 oz Navy Tumbler",
    description: "30 oz Navy Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/653_20250824_133455.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 651,
    name: "30 oz Black Tumbler",
    description: "30 oz Black Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/651_20250824_133511.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 628,
    name: "40 oz Pink Organization Travel Mug",
    description: "40 oz Pink Organization Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/628_20250824_133602.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 626,
    name: "40 oz Black Organization Travel Mug",
    description: "40 oz Black Organization Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/626_20250824_133624.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 605,
    name: "40 oz White Travel Mug",
    description: "40 oz White Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/605_20250824_133632.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 603,
    name: "40 oz Pink Travel Mug",
    description: "40 oz Pink Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/603_20250824_133647.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 602,
    name: "40 oz Light Blue Travel Mug",
    description: "40 oz Light Blue Travel Mug",
    base_price: 50,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/602_20250824_133654.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 579,
    name: "40 oz Navy Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/579_20250824_133804.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 133,
    name: "Queso Cashews",
    description: "Queso Cashews",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/133_20260317_172659.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 204,
    name: "Caramel & Cheese Popcorn 16oz",
    description:
      "Gluten FreeChicago popcorn, a perfect blend of sweet        caramel and savory cheddar cheese, creates a delicious harmony of flavors,        offering a uniquely delightful and satisfying snacking experience in every        handful. Family Size Bag – 16 oz",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/204_20250824_133139.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
  {
    sku: 552,
    name: "40 oz Green Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/552_20250824_133857.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 486,
    name: "White Custom Hoodie",
    description: "White Custom Hoodie",
    base_price: 55,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/486_20250824_134003.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 680,
    name: "30 oz Royal Organization Tumbler",
    description: "30 oz Royal Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/680_20250824_133325.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 678,
    name: "30 oz Navy Organization Tumbler",
    description: "30 oz Navy Organization Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/678_20250824_133347.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 656,
    name: "30 oz White Tumbler",
    description: "30 oz White Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/656_20250824_133432.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 654,
    name: "30 oz Red Tumbler",
    description: "30 oz Red Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/654_20250824_133448.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 652,
    name: "30 oz Green Tumbler",
    description: "30 oz Green Tumbler",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/652_20250824_133503.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 582,
    name: "40 oz Royal Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/582_20250824_133740.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 581,
    name: "40 oz Red Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/581_20250824_133746.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 578,
    name: "40 oz Green Organization Bottle",
    description:
      "Rep your organization pride with our customized water bottle! Our 40 oz water bottle comes with a straw and an awesome         engraved designed. No worrying about peeling or fade! Our bottles are all 18/8 stainless steel and vacuum sealed, meaning they will         hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/578_20250824_133811.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 553,
    name: "40 oz Navy Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/553_20250824_133850.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 551,
    name: "40 oz Burgundy Bottle",
    description:
      "Our 40 oz water bottle comes with a straw and an awesome engraved design.         No worrying about peeling or fading! Our bottles are all 18/8 stainless steel and vacuum sealed,         meaning they will hold cold for over 24 hours and hot for over 8 hours.",
    base_price: 40,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/551_20250824_133902.png",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: true,
  },
  {
    sku: 134,
    name: "Donut Flavored Cashews",
    description: "Donut Flavored Cashews",
    base_price: 20,
    images: [
      "https://prod-mamfam-data.s3.amazonaws.com/products/134_20260317_172731.jpg",
    ],
    features: [],
    variants: {
      style_variants: [],
      color_variants: [],
    },
    is_customizable: false,
  },
];

export default products;
